import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { MeetingsToDoListPage } from './meetings-to-do-list';
import { UserHeaderComponentModule } from '../../components/header/header.module';
import { MomentModule } from 'ngx-moment';

@NgModule({
  declarations: [
    MeetingsToDoListPage,
  ],
  imports: [
    IonicPageModule.forChild(MeetingsToDoListPage),
    UserHeaderComponentModule,
    MomentModule
  ],
})
export class MeetingsToDoListPageModule {}



// WEBPACK FOOTER //
// ./src/pages/meetings-to-do-list/meetings-to-do-list.module.ts